export const BaseIcon = () => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_3386_32773)'>
      <mask
        id='mask0_3386_32773'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <path d='M0 0H24V24H0V0Z' fill='white' />
      </mask>
      <g mask='url(#mask0_3386_32773)'>
        <path d='M24 0H0V24H24V0Z' fill='#0052FF' />
        <path
          d='M11.986 20C16.412 20 20 16.418 20 12C20 7.582 16.412 4 11.986 4C9.9788 3.99873 8.04427 4.75109 6.56535 6.10816C5.08642 7.46523 4.1709 9.32809 4 11.328H14.593V12.673H4C4.342 16.776 7.787 20 11.986 20Z'
          fill='white'
        />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_3386_32773'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
